import { render, staticRenderFns } from "./FreightTableCarriersFilters.vue?vue&type=template&id=3c36cf80&scoped=true"
import script from "./FreightTableCarriersFilters.vue?vue&type=script&lang=js"
export * from "./FreightTableCarriersFilters.vue?vue&type=script&lang=js"
import style0 from "./FreightTableCarriersFilters.vue?vue&type=style&index=0&id=3c36cf80&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c36cf80",
  null
  
)

export default component.exports